import api from "../components/api/api";

class AuthService {
  sessionVersion = 0;
  /**
   * Получает все данные текущего пользователя из localStorage
   */
  getCurrentUser() {
    return {
      token: localStorage.getItem("token"),
      role: localStorage.getItem("role"),
      email: localStorage.getItem("user_email"),
      user_id: localStorage.getItem("user_id"),
      company_id: localStorage.getItem("company_id"),
      subscription_expired: localStorage.getItem("subscription_expired")
    };
  }

  /**
   * Проверяет, авторизован ли пользователь
   */
  isAuthenticated() {
    const token = localStorage.getItem("token");
    return !!token;
  }

  /**
   * Получает роль текущего пользователя
   */
  getUserRole() {
    return localStorage.getItem("role");
  }

  /**
   * Декодирует JWT токен (только для отладки, небезопасно для продакшена)
   */
  decodeTokenPayload(token) {
    try {
      if (!token) return null;
      
      const parts = token.split('.');
      if (parts.length !== 3) return null;
      
      const encoded = parts[1].replace(/-/g, '+').replace(/_/g, '/');
      const bytes = atob(encoded.padEnd(Math.ceil(encoded.length / 4) * 4, '='));
      const payload = JSON.parse(decodeURIComponent(Array.from(bytes, ch =>
        '%' + ch.charCodeAt(0).toString(16).padStart(2, '0')).join('')));
      
      return {
        user_id: payload.sub,
        company_id: payload.company_id,
        role: payload.role,
        email: payload.email
      };
    } catch {
      return null;
    }
  }

  /**
   * Загружает данные пользователя с сервера и обновляет localStorage
   */
  async fetchAndUpdateUserData() {
    const version = this.sessionVersion;
    const requestedToken = localStorage.getItem("token");
    const isCurrentSession = () => version === this.sessionVersion && requestedToken === localStorage.getItem("token");
    try {
      const response = await api.get("/login/me");
      if (!isCurrentSession()) throw new Error("Сеанс изменился во время загрузки");
      
      const { user_id, company_id, role, email } = response.data;
      
      // Обновляем localStorage
      localStorage.setItem("role", role);
      localStorage.setItem("user_email", email);
      localStorage.setItem("user_id", user_id);
      localStorage.setItem("company_id", company_id);
      
      
      return { user_id, company_id, role, email };
    } catch (error) {
      if (!isCurrentSession()) throw error;
      if (error.response?.status === 401 || error.response?.status === 403) {
        this.logout();
        throw error;
      }
      
      // Запасной вариант - попробуем декодировать токен
      const token = localStorage.getItem("token");
      if (token) {
        const decoded = this.decodeTokenPayload(token);
        if (decoded && decoded.role) {
          
          // Сохраняем данные из токена
          localStorage.setItem("role", decoded.role);
          localStorage.setItem("user_email", decoded.email || "");
          localStorage.setItem("user_id", decoded.user_id || "");
          localStorage.setItem("company_id", decoded.company_id || "");
          
          return decoded;
        }
      }
      
      throw error;
    }
  }

  /**
   * Очищает все данные пользователя из localStorage
   */
  logout() {
    this.sessionVersion += 1;
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("user_email");
    localStorage.removeItem("user_id");
    localStorage.removeItem("company_id");
    localStorage.removeItem("subscription_expired");
  }

  /**
   * Безопасно получает роль пользователя, загружая её с сервера если необходимо
   */
  async getSafeUserRole() {
    let role = localStorage.getItem("role");
    
    
    if (!role || role === "null" || role === "undefined") {
      try {
        const userData = await this.fetchAndUpdateUserData();
        role = userData.role;
      } catch {
        throw new Error("Неизвестная роль пользователя");
      }
    }
    
    return role;
  }
}

const authService = new AuthService();
export default authService;
